import * as z$1 from "zod/v4";
//#region src/schemas/daemon/conversation-lifecycle.ts
const conversationBootstrapReasonSchema = z$1.enum([
	"missing_bootstrap_state",
	"compatibility_recreate",
	"template_changed",
	"idle_stale",
	"dispatch_count_stale",
	"context_healed",
	"context_replaced"
]);
const localRuntimeContextReasonSchema = z$1.enum([
	"first_local_runtime_context",
	"workspace_changed",
	"transport_mode_changed",
	"policy_changed",
	"execution_state_missing",
	"controller_changed"
]);
const agentControllerConversationResumePlanBlockedReasonSchema = z$1.enum(["controller_changed"]);
const agentControllerConversationResumePlanSchema = z$1.discriminatedUnion("status", [
	z$1.strictObject({ status: z$1.literal("not_bound") }),
	z$1.strictObject({ status: z$1.literal("continue_existing") }),
	z$1.strictObject({
		status: z$1.literal("blocked"),
		reason: agentControllerConversationResumePlanBlockedReasonSchema
	})
]);
const localRuntimeContextPlanSchema = z$1.strictObject({
	status: z$1.enum(["reuse", "recreate"]),
	reason: z$1.union([localRuntimeContextReasonSchema, z$1.null()])
});
const conversationBootstrapSchema = z$1.discriminatedUnion("status", [z$1.strictObject({
	reason: z$1.null(),
	status: z$1.literal("applied")
}), z$1.strictObject({
	reason: conversationBootstrapReasonSchema,
	status: z$1.literal("pending")
})]);
const nextDispatchPlanSchema = z$1.strictObject({
	agentControllerConversationResume: agentControllerConversationResumePlanSchema,
	localRuntimeContext: localRuntimeContextPlanSchema,
	bootstrap: conversationBootstrapSchema
});
const agentControllerConversationResumeSchema = z$1.discriminatedUnion("status", [
	z$1.strictObject({ status: z$1.literal("not_bound") }),
	z$1.strictObject({ status: z$1.literal("continued") }),
	z$1.strictObject({ status: z$1.literal("replaced_by_provider") })
]);
const localRuntimeContextExecutionSchema = z$1.strictObject({
	status: z$1.enum(["reused", "recreated"]),
	reason: z$1.union([localRuntimeContextReasonSchema, z$1.null()])
});
const dispatchExecutionSchema = z$1.strictObject({
	agentControllerConversationResume: agentControllerConversationResumeSchema,
	localRuntimeContext: localRuntimeContextExecutionSchema,
	bootstrap: conversationBootstrapSchema
});
//#endregion
export { agentControllerConversationResumePlanBlockedReasonSchema, agentControllerConversationResumePlanSchema, agentControllerConversationResumeSchema, conversationBootstrapReasonSchema, conversationBootstrapSchema, dispatchExecutionSchema, localRuntimeContextExecutionSchema, localRuntimeContextPlanSchema, localRuntimeContextReasonSchema, nextDispatchPlanSchema };

//# sourceMappingURL=conversation-lifecycle.js.map